// extracted by mini-css-extract-plugin
export default {"bottom_box":"index_bottom_box_5c6Ym"};